import { Link } from '@tanstack/react-router'
import { Siren } from 'lucide-react'
import { useEffect, useState } from 'react'
import { usePermission } from '@/hooks/use-permission'
import { useEmergencyBroadcasts } from '../api'

/** App-shell banner while any broadcast is live (polled every 30 s; displays.view only). */
export function EmergencyBanner() {
  const canView = usePermission('displays.view')
  const query = useEmergencyBroadcasts({ enabled: canView, poll: true })
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 15_000)
    return () => window.clearInterval(t)
  }, [])
  // The server status is a snapshot; also hide broadcasts whose end passed since the last poll.
  const active = (query.data ?? []).filter((b) => b.status === 'active' && Date.parse(b.ends_at) > now)
  if (!canView || active.length === 0) return null
  const first = active[0]!
  const until = new Intl.DateTimeFormat(undefined, { timeStyle: 'short' }).format(new Date(first.ends_at))
  return (
    <div role="alert" className="relative z-30 flex items-center justify-center gap-3 bg-danger px-4 py-1.5 text-[13px] font-medium text-white">
      <Siren className="size-4 shrink-0 animate-pulse" />
      <span className="truncate">
        {active.length === 1 ? (
          <>
            Emergency broadcast active: <strong>{first.name}</strong> until {until}
          </>
        ) : (
          <>{active.length} emergency broadcasts are active</>
        )}
      </span>
      <Link to="/emergency" className="shrink-0 rounded-md bg-white/15 px-2 py-0.5 underline-offset-2 hover:bg-white/25 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none">
        Manage
      </Link>
    </div>
  )
}
